// contexts/UserContext.jsx
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorageDB } from "hooks/useLocalStorageDB";
import { CTSNAP } from "clases/CTSNAP";
import { ChevronsRightLeft } from "lucide-react";

const UserContext = createContext();


export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [listaGeneral, setListaGeneral] = useState({
    user_nom: "",
    user_dpto: "",
    Empresa: "",
  });
  const [matchCodes, setMatchCodes] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [error, setError] = useState("");

  const [menuMap, setMenuMap] = useState(new Map());
  const [menuMapR, setMenuMapR] = useState(new Map());
  const [loadingMenus, setLoadingMenus] = useState(false);
  const [pas,setpas]=useState("");


    // --- Integración de terminalConfig ---
  const terminalConfig = useLocalStorageDB(); // pcId, terminalId, userId, password, set*, handleSubm
  const navigate = useNavigate();

  //  Función para validar token con el servidor
  const validateToken = async (userData) => {
    if (!userData?.id || !userData?.token) return false;

    try {
      const snap = new CTSNAP({
        useUserId: true,
        useToken: true,
        user: userData,
      });
      snap.setFuncion("api/acces");
      snap.setMetodo("GET");
      snap.setParam("metode", "STARTUP");
      const res = await snap.fetchData();

      if (res?.valid || (res.Error && res.Error.ID === 0)) {
        return true;
      } else {
        console.warn("Token inválido o expirado:", res?.Error?.TXT);
        return false;
      }
    } catch (err) {
      console.error("Error al validar token:", err);
      return false;
    }
  };

  const initializeUser = async () => {
    //const storedUser = localStorage.getItem("chronos_user");
 
    //if (!storedUser) {
      setInitialLoad(false);
          const userData = {
          id: -1,
          email: "",
          name: "",
          perfil: "",
          username: "",
          token: "",
          appDes: "TrcSystem",
          empresa: "TrcSysten",
         };
      setUser(userData); 
      
  

     return;
/*    }

    try {
      const parsedUser = JSON.parse(storedUser);

      // Verificar token antes de restaurar
     // const isValid = await validateToken(parsedUser);
      const isValid=true;
      if (!isValid) {
        console.log("Token expirado. Cerrando sesión.");
        logoutUser();
        setInitialLoad(false);
        return;
      }

      // Token válido, restaurar sesión
      setUser(parsedUser);
      setListaGeneral({
        user_nom: parsedUser.name || "",
        user_dpto: parsedUser.dpto || "",
        Empresa: parsedUser.empresa || "",
      });

      // Menús
      const lsmenus = localStorage.getItem("chronos_user_menu");
      if (lsmenus) {
        try {
          loadMenus(JSON.parse(lsmenus));
        } catch {
          localStorage.removeItem("chronos_user_menu");
        }
      }

      // Matchcodes
      const lsmatch = localStorage.getItem("chronos_user_match");
      if (lsmatch) {
        try {
          setMatchCodes(JSON.parse(lsmatch));
        } catch {
          localStorage.removeItem("chronos_user_match");
        }
      }
    } catch (err) {
      console.error("Error al cargar sesión:", err);
      localStorage.removeItem("chornos_user");
    } finally {
      setInitialLoad(false);
    }
      */
  };

  useEffect(() => {
    initializeUser(); // 👈 llamada real
  }, []);

  
  // loginUser ahora se encarga de verificar en backend
  const loginUser = async (username, password) => {
    const snap = new CTSNAP();
    snap.setFuncion("/apisys/login");
    snap.setMetodo("POST");
    snap.setParamBody("username", username);
    snap.setParamBody("password", password);
    snap.setParamBody("id", "050");

    try {
      const data = await snap.fetchData();

      if (!data.Error?.ID) {
        const userData = {
          id: data.ID,
          email: data.EMAIL,
          name: data.NOM,
          perfil: data.PERFIL,
          username: data.USER,
          token: data.token,
          appDes: data.APPDES,
          empresa: data.EMPRESA,
          operari_id: data.OPERARIID|| "",
          operari: data.OPERARI || "",
          presencia: data.PRESENCIA || "",
          planta: data.PLANTA || "",
          visor: data.VISOR || ""
        };

        // Guarda usuario en estado y localStorage
        setUser(userData);
     
        localStorage.setItem("chronos_user", JSON.stringify(userData));

        setListaGeneral({
          user_nom: userData.name || "",
          user_dpto: userData.dpto || "",
          Empresa: userData.empresa || "",
        });

        fetchStartUp(userData);

        return { success: true, data: userData }; // devuelve éxito
      } else {
        return {
          success: false,
          error: data.Error?.TXT || "Credenciales inválidas",
        };
      }
    } catch (err) {
      console.error(err);
      return { success: false, error: "Error en el servidor" };
    }
  };

  // logout
  const logoutUser = () => {
    const presencia=user.presencia;
    const planta=user.planta;
    const visor=user.visor;

    setUser(null);
    
    localStorage.removeItem("chronos_user");
    localStorage.removeItem("chornos_user_menu");
    localStorage.removeItem("chornos_user_match");

    setListaGeneral({
      user_nom: "",
      user_dpto: "",
      Empresa: "",
    });

    setMatchCodes([]);
    setMenuMap(new Map());
    setMenuMapR(new Map());

    if(presencia==="X" && planta==="")
    {navigate("/login"); } 
    else if(planta==="X") 
        {navigate("/start"); } 
     else { navigate("/login");}
  };

// contexts/UserContext.jsx
const loginTerminal = async ({operari }) => {
  

  if (terminalConfig.terminalId && terminalConfig.userId && terminalConfig.password) {
    try {
      const operario = operari || "";
      const kk =`${terminalConfig.terminalId}&${terminalConfig.userId}&${operario}`;
 
      setpas(btoa(terminalConfig.password));
      const snap = new CTSNAP();
      snap.setFuncion("/apisys/login");
      snap.setMetodo("POST");
      snap.setParamBody("username", kk);
      snap.setParamBody("password", terminalConfig.password);
      
      const data = await snap.fetchData();
    

      if (!data.Error?.ID) {
     
        const userData = {
          id: data.ID,
          email: data.EMAIL,
          name: data.NOM,
          perfil: data.PERFIL,
          username: data.USER,
          token: data.token,
          appDes: data.APPDES,
          empresa: data.EMPRESA,
          operari_id: data.OPERARIID,
          operari: data.OPERARI,
          presencia: data.PRESENCIA,
          planta: data.PLANTA,
          visor: data.VISOR
        };
       
       
         setUser(userData);
         localStorage.setItem("chronos_user", JSON.stringify(userData));

         /*********************
          * Falta carga de parametres 
          * 
          */
      
        return { success: true, data };
      } else {
        console.warn("Login de terminal fallido:", data.Error.TXT);
        return { success: false, error: data.Error.TXT };
      }
    } catch (err) {
      console.error("Error login terminal:", err);
      return { success: false, error: err.message };
    }
  } else {
    console.warn("No hay credenciales de terminal para login");
    return { success: false, error: "Credenciales incompletas" };
  }
};



const refreshUserToken = async () => {
  
  if (!user?.id || !user?.token) return false;


  try {
    const snap = new CTSNAP();
      
      snap.setFuncion("/apisys/login");
      snap.setMetodo("POST");
      snap.setParamBody("username", user);
      
    const res = await snap.fetchData();

    if (!res.Error?.ID && res.token) {
      const updatedUser = { ...user,  id: res.ID, token: res.token };
      
      setUser(updatedUser);
      return true;
    } else {
      console.warn("Token inválido o expirado:", res.Error?.TXT);
      return false;
    }
  } catch (err) {
    console.error("Error al refrescar token:", err);
    return false;
  }
};


  const fetchStartUp = async (userData) => {
    try {
      const snap = new CTSNAP({
        useUserId: true,
        useToken: true,
        user: userData,
      });
      snap.setFuncion("api/acces");
      snap.setMetodo("GET");
      snap.setParam("metode", "STARTUP");

      const data = await snap.fetchData();

      if (data.Error && data.Error.ID > 0) {
        console.error("Error en fetchStartUp:", data.Error);
        setError("Error la carga inicial");
        return;
      }
      // 1. Carga els menus en les variables
      loadMenus(data?.LSMenus || []);
      localStorage.setItem("user_menu", JSON.stringify(data?.LSMenus || []));

      // 2. Cargar Matchcodes
      const matchList = data?.LSMatch || [];
      setMatchCodes(matchList);
      localStorage.setItem("user_match", JSON.stringify(matchList));
    } catch (err) {
      console.error("Error en fetchMatchCodes:", err);
      setError("Error en el servidor");
    }
  };

  // 👉 función para cargar datos de un matchCode específico (por FICHA)
  const loadMatchCodeData = async (ficha) => {
    try {
      const snap = new CTSNAP({ useUserId: true, useToken: true, user });
      snap.setFuncion("api/matchcode");
      snap.setMetodo("GET");
      snap.setParam("metode", "LOAD");
      snap.setParam("consulta", ficha);

      const data = await snap.fetchData();

      if (data.Error && data.Error.ID > 0) {
        console.error("Error en matchcode", ficha, data.Error.TXT);
        return [];
      }

      return data.LSBF || [];
    } catch (err) {
      console.error("Error cargando matchcode", ficha, err);
      return [];
    }
  };

  const setListaVariable = (key, value) => {
    setListaGeneral((prev) => ({ ...prev, [key]: value }));
  };

  const loadMenus = (lsMenus) => {
    try {
      const map = new Map();
      const mapR = new Map();

      lsMenus?.forEach((menu) => {
        if (menu.IDBUTO === 1) {
          if (menu.TIPO === "0") {
            map.set(menu.MENU_PARENT, { ...menu, submenus: [] });
          } else if (map.has(menu.MENU_PARENT)) {
            map.get(menu.MENU_PARENT).submenus.push(menu);
          }
        }

        if (menu.IDBUTO === 2 && menu.TIPO === "1") {
          if (!mapR.has(menu.ID_MENU)) mapR.set(menu.ID_MENU, []);
          mapR.get(menu.ID_MENU).push(menu);
        }
      });

      setMenuMap(map);
      setMenuMapR(mapR);
    } catch (err) {
      console.error("Error al cargar configuración:", err);
    } finally {
      setLoadingMenus(false);
    }
  };

  const contextValue = useMemo(
    () => ({
      user,
      listaGeneral,
      setListaVariable,
      matchCodes,
      loadMatchCodeData, // 👉 función pública para cargar un matchcode bajo demanda
      refreshMatchCodes: () => {
        //   if (user) fetchMatchCodes(user);  // ull aquesta funcio ens permet carregar en calent els matchcode d'inci o de cache
      },
      error,
      loginUser,
      logoutUser,
      loadingUser: initialLoad && !user,
      menuMap, // 🧭 ahora disponible globalmente
      menuMapR, // 🧭 idem
      loadingMenus,
      loginTerminal,
      refreshUserToken,
        ...terminalConfig, // pcId, terminalId, userId, password, set*, handleSubmitConfig
    }),
    [
      user,
      listaGeneral,
      matchCodes,
      menuMap,
      menuMapR,
      loadingMenus,
      initialLoad,
      error,
       terminalConfig,
    ]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
